import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import QueryParams from '../../services/QueryParams';
import FormData from '../../services/FormData';
import Http from '../../services/Http';
import Storage from '../../services/Storage';
import Logo from '../../logos/logo-white.png';
import { Link } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const Login = (props: any) => {
    const [http] = useState(new Http());
    const [storage] = useState(new Storage());
    const [queryParams] = useState(new QueryParams());
    const [signingIn, setSigningIn] = useState(false);
    const [token, setToken] = useState(storage.token());

    const login = async (e: any) => {
        e.preventDefault();
        let login;
        setSigningIn(true);
        try {
            login = await http.post('authenticate', new FormData('login_form').toJson());
            if (login.status < 400) {
                toast.success("Login successful");
                storage.token(login.data.token);
                storage.email(login.data.email);
                setTimeout(function () {
                    redirect();
                }, 1000);
            } else {
                toast.error(login && login.data && login.data.message || "Something went wrong.");
                setSigningIn(false);
            }
        } catch (e: any) {
            toast.error(e && e.response && e.response.data && e.response.data.message ? e.response.data.message : ((e && e.message) || "Something went wrong."));
            setSigningIn(false);
        }
    }

    const redirect = useCallback(() => {
        if (queryParams.get("returnTo")) {
            window.location.href = queryParams.get("returnTo");
        } else {
            window.location.href = `${process.env.REACT_APP_IEC_ID_URL}`;
        }
    }, [queryParams]);

    window.addEventListener("storage", function (e: any) {
        console.log(e);
        if (storage.token()) {
            setToken(storage.token());
        }
    });

    const handleError = useCallback((resp: any) => {
            switch (resp.status) {
                case 401:
                    storage.remove("sso_token");
                    setToken("");
                    break;

                case 403:
                    redirect();
                    break;

                default:
                    toast.info(resp.data.message);
                    break;
            }
        }, [redirect, storage]);

    useEffect(() => {
        if (token) {
            http.secureGet(`mock`)
                .then((resp: any) => {
                    if (resp.status === 200) {
                        console.log("mock successful");
                        redirect();
                    } else {
                        handleError(resp);
                    }
                })
                .catch((error: any) => {
                    if (error.response) {
                        handleError(error.response);
                    } else {
                        toast.error("Something went wrong!");
                    }
                });
        }
    }, [handleError, http, redirect, token]);

    return (
        <div className="global-container bg-gradient">
            <div id="tweak">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-flex">
                            <div className="mt-auto mb-auto text-center text-md-left">
                                <img src={Logo} style={{ pointerEvents: 'none' }} width="240" alt="" />
                                <h4 className="text-white mt-4 d-inline-block" style={{ lineHeight: 1.5 }}>
                                    {props.isOnScreen ?
                                        <span>Your session was expired! Please sign in again to continue.</span>
                                        :
                                        <span>Please sign in to continue. One account for everything at insurEco.</span>}
                                </h4>
                                {!props.isOnScreen && <Link to="/learn-more" target="_blank" className="btn btn-light mt-3 d-none d-md-inline-block" rel="noreferrer">Learn more</Link>}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="card login-form mt-4 ml-auto mr-auto">
                                <div className="card-body">
                                    <div className="card-text">
                                        <form name="login_form" onSubmit={login} id="login_form">
                                            <div className="form-group">
                                                {IEVersion() < 10 ? <label>Email address</label> : <span></span>}
                                                {
                                                    props.isOnScreen ?
                                                        <span>
                                                            Enter password for <strong>{storage.email()}</strong>
                                                            {/* <a onClick={switchAccount}></a> */}
                                                            <input type="hidden" id="username" name="username" value={storage.email() || ''} />
                                                        </span>
                                                        :
                                                        <input type="email" placeholder="Email address" className="form-control form-control-lg" id="username" name="username" />
                                                }
                                            </div>
                                            <div className="form-group">
                                                {IEVersion() < 10 && !props.isOnScreen ? <label>Password</label> : <span></span>}
                                                <input type="password" placeholder="Password" className="form-control form-control-lg" id="password" name="password" />
                                            </div>
                                            <button type="submit" disabled={signingIn} className="btn btn-secondary btn-lg btn-block">
                                                {signingIn ? <span> Signing In&hellip;</span> : "Sign In"}
                                                {signingIn ? <span>
                                                    &nbsp;&nbsp;
                                                    <FontAwesomeIcon icon={faSpinner} className="fa-spin" />
                                                </span> : <span></span>}
                                            </button>
                                            <div className="text-center mt-3">
                                                <Link className="text-secondary" to="forgot-password">Forgot password?</Link>
                                            </div>
                                            <div className="sign-up text-center">
                                                <button disabled type="submit" className="btn btn-success btn-lg">Create New Account</button>
                                            </div>
                                            <div className="text-center pt-3">
                                                <small className="text-muted">
                                                    <a className="text-secondary" href="https://app.raterspot.com/privacy.html" rel="noreferrer" target="_blank">Terms of Services</a> and <a href="https://app.raterspot.com/privacy.html" className="text-secondary" rel="noreferrer" target="_blank">Privacy Policy</a>
                                                </small>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="text-center copyright">
                <small className="text-light">Copyright {new Date().getFullYear()} &copy; insurEco System</small>
            </div>
        </div>
    );
}

const IEVersion = (): number => {

    /**
     * detect IE
     * returns version of IE or false, if browser is not Internet Explorer
     */
    function detectIE() {
        var ua = window.navigator.userAgent;

        // Test values; Uncomment to check result …

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // Edge 12 (Spartan)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge 13
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        var edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return 99;
    }

    return detectIE();
}

export default Login;